// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"179":"3ca085c7","190":"9e76ff1a","330":"1309b2b7","363":"59e2eb26","453":"2198947a","455":"3f00f825","501":"26f14fd3","521":"fd34a886","634":"f6d5434d","803":"4010c5f1","836":"e966deab"}[chunkId] + ".chunk.js";
};